/**
 * The labels the intent drawer puts on each field.
 *
 * Anything that shows a transaction field to a user reads them from here, so a
 * column in the drafts table and a row in the import mapping screen are called
 * the same thing the drawer calls them. The user learned these words in the
 * drawer; inventing synonyms elsewhere ("Opis" for what the drawer calls
 * "Naziv") just makes them translate.
 *
 * Sources, so the two stay in step:
 *   IntentFields/DefaultFields.js, PersonalFields.js, TransferFields.js,
 *   IntentFields/TagField.js, IntentDrawer.js
 *
 * `date_to_be_paid` is the one that moves: the drawer calls it "Realizirano"
 * alongside the invoice dates, but "Datum" in personal mode where it is the
 * only date there is.
 */

export const intentFieldLabel = (field, orgConfig) => {
  if (field === 'date_to_be_paid') {
    return orgConfig?.single_date ? 'Datum' : 'Realizirano';
  }
  return INTENT_FIELD_LABELS[field] || null;
};

const INTENT_FIELD_LABELS = {
  type: 'Tip',
  amount: 'Znesek',
  amount_no_tax: 'Znesek brez DDV',
  tax_amount: 'Znesek DDV',
  tax_rate: 'Stopnja DDV',
  title: 'Naziv',
  descr: 'Opis',
  date_invoice_recieved: 'Prejeto',
  date_service_performed: 'Opravljeno',
  account: 'Račun',
  transfer_from_account: 'Iz računa',
  transfer_to_account: 'Na račun',
  company: 'Podjetje',
  person: 'Oseba',
  category: 'Kategorija',
  project: 'Projekt',
  tag: 'Oznaka',
  invoice_number: 'Št. računa',
  is_paid: 'Plačano',
  is_issued: 'Izdano',
};

/**
 * Labels for the import mapping screen.
 *
 * Most targets are real intent fields and reuse the drawer's word. The rest
 * exist only while reading a file -- a counterparty the importer still has to
 * resolve to a Podjetje or an Oseba, and the two shapes a statement writes an
 * amount in -- so they are named here and nowhere else.
 */
export const importTargetLabel = (field, orgConfig) => (
  intentFieldLabel(field, orgConfig) || IMPORT_ONLY_LABELS[field] || field
);

const IMPORT_ONLY_LABELS = {
  debit: 'Breme (odhodek)',
  credit: 'Dobro (prihodek)',
  counterparty_name: 'Podjetje / oseba',
  counterparty_iban: 'IBAN druge strani',
  counterparty_tax_id: 'Davčna številka',
  category_name: 'Kategorija',
  tag_name: 'Oznaka',
  external_ref: 'Referenca transakcije',
};

export default intentFieldLabel;
